import 'css-chunksrc/client/scenes/constraintEdition/endStartForm/styles.scss';export default {
  "form": "_form_oedzz_1"
};